import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-user-conected-card',
  templateUrl: './user-conected-card.component.html',
  styleUrls: ['./user-conected-card.component.scss'],
})
export class UserConectedCardComponent implements OnInit {
  constructor() {}

  @Input() user: any;
  ngOnInit() {}
}
